import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
/**
 * 手机端(<480px)：主页 tab 固定 + 只保留一个已打开页面（新的替换旧的）
 */
const isMobile = () => typeof window !== 'undefined' && document.documentElement.clientWidth <= 480;
const onlyHomeAndLatest = routes => {
  const home = routes.filter(r => r.meta.noClosable);
  const latest = routes.filter(r => !r.meta.noClosable).slice(-1);
  return home.length ? [...home, ...latest] : routes;
};
export const useTabsStore = defineStore('tabs', {
  state: () => ({
    // 页面刷新时从 sessionStorage 恢复
    visitedRoutes: isMobile() ? onlyHomeAndLatest(JSON.parse(sessionStorage.getItem('visitedRoutes') || '[]')) : JSON.parse(sessionStorage.getItem('visitedRoutes') || '[]'),
    activeRoute: '' // 当前激活的tab路由名称
  }),
  getters: {
    getVisitedRoutes: state => state.visitedRoutes.filter(route => route.name !== 'Login')
  },
  actions: {
    setActiveRoute(routeName) {
      this.activeRoute = routeName;
    },
    /**
     * @description 保存到 sessionStorage
     */
    saveToStorage() {
      sessionStorage.setItem('visitedRoutes', JSON.stringify(this.visitedRoutes));
    },
    /**
     * @description 添加标签页
     */
    addVisitedRoute(route) {
      const target = this.visitedRoutes.find(item => item.path === route.path);
      if (target && !route.meta.dynamicNewTab) Object.assign(target, route);else if (!target) this.visitedRoutes.push(Object.assign({}, route));
      // 应对极特殊情况：没有配置noClosable的情况，默认使当前tab不可关闭
      if (!this.visitedRoutes.find(r => r.meta.noClosable)) this.visitedRoutes[0].meta.noClosable = true;
      // 手机端：主页固定 + 当前页，打开新页面时替换旧页面，避免 tab 无限堆叠
      if (isMobile()) {
        this.visitedRoutes = onlyHomeAndLatest(this.visitedRoutes);
      }
      this.saveToStorage();
    },
    /**
     * @description 删除当前标签页
     */
    delVisitedRoute(path) {
      this.visitedRoutes = this.visitedRoutes.filter(route => route.path !== path);
      this.saveToStorage();
    },
    /**
     * @description 删除当前标签页以外其它全部标签页
     */
    delOthersVisitedRoutes(path) {
      this.visitedRoutes = this.visitedRoutes.filter(route => route.meta.noClosable || route.path === path);
      this.saveToStorage();
    },
    /**
     * @description 删除当前标签页左边全部标签页
     */
    delLeftVisitedRoutes(path) {
      let found = false;
      this.visitedRoutes = this.visitedRoutes.filter(route => {
        if (route.path === path) found = true;
        return route.meta.noClosable || found;
      });
      this.saveToStorage();
    },
    /**
     * @description 删除当前标签页右边全部标签页
     */
    delRightVisitedRoutes(path) {
      let found = false;
      this.visitedRoutes = this.visitedRoutes.filter(route => {
        const close = found;
        if (route.path === path) found = true;
        return route.meta.noClosable || !close;
      });
      this.saveToStorage();
    },
    /**
     * @description 删除全部标签页
     */
    delAllVisitedRoutes() {
      this.visitedRoutes = this.visitedRoutes.filter(route => route.meta.noClosable);
      this.saveToStorage();
    },
    /**
     * @description 修改 meta
     */
    changeTabsMeta(options) {
      function handleVisitedRoutes(visitedRoutes) {
        return visitedRoutes.map(route => {
          if (route.name === options.name || route.meta.title === options.title) Object.assign(route.meta, options.meta);
          if (route.children && route.children.length) route.children = handleVisitedRoutes(route.children);
          return route;
        });
      }
      this.visitedRoutes = handleVisitedRoutes(this.visitedRoutes);
      this.saveToStorage();
    }
  }
});